
'use client';

// components/justForYou/index.js
import './index.scss'
import { Flex, Empty} from 'antd'
import ProductItem from '../common/ProductItem/product';
import { useEffect, useState } from 'react';
import { createClientService } from '@/lib/http/client';
import AsyncSection from '@/components/common/AsyncSection'

export default function JustForYou() {

    const [recommendList, setRecommendList] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // 961016_yibuy首页产品为你推荐列表接口
        createClientService().get('mtop.search.yibuy.product.recommend', { data: { pageNo: 1, pageSize: 100 } }).then(res => {
            setRecommendList(res?.products || [])
        }).catch(err => {
            console.error(err);
        }).finally(() => {
            setLoading(false);
        })
    }, [])

    return (


        <AsyncSection className='box_warp just_for_you' title='Just For You'>
            <Flex className='product_bx'>
                {recommendList.length > 0 ?
                    recommendList.map((item, key) => (
                        <ProductItem key={key} item={item} />
                    ))
                    : <Empty description="No products found" style={{ margin: '40px auto' }} />}
            </Flex>
        </AsyncSection>

    );
}